import {Link} from 'react-router';

type PageHeaderPropsT = {
  currentPage: string;
  activePage: string;
  mainPage: string;
  handleBack?: () => void;
};

export default function PageHeader({currentPage, activePage, mainPage, handleBack}: PageHeaderPropsT) {
  return (
    <div className="page-header block justify-between md:flex">
      <div className="mb-4 flex min-w-0 items-center md:mb-0">
        {handleBack && (
          <button onClick={handleBack} className="flex items-center text-primary hover:text-primary dark:text-primary">
            <i className="ti ti-arrow-left flex-shrink-0 px-[0.5rem] text-[#8c9097] dark:text-white/50"></i>
          </button>
        )}
        <h3 className="text-[1.125rem] font-semibold !text-defaulttextcolor dark:!text-defaulttextcolor/70 dark:text-white dark:hover:text-white">
          {currentPage}
        </h3>
      </div>
      <ol className="flex min-w-0 items-center whitespace-nowrap">
        <li className="ps-[0.5rem] text-[0.813rem]">
          <Link className="flex items-center truncate text-primary hover:text-primary dark:text-primary" to="#">
            {activePage}
            <i className="ti ti-chevrons-right flex-shrink-0 overflow-visible px-[0.5rem] text-[#8c9097] dark:text-white/50 rtl:rotate-180"></i>
          </Link>
        </li>
        <li
          className="text-[0.813rem] font-semibold text-defaulttextcolor hover:text-primary dark:text-[#8c9097] dark:text-white/50"
          aria-current="page"
        >
          {mainPage}
        </li>
      </ol>
    </div>
  );
}
